// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  color: #707070;
  /* background-color: #ebedef; */
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

h1 {
  color: #6c757d;
  text-transform: uppercase;
}

input {
  border: 1px solid #dfdfdf;
  border-radius: 4px;
}

input:focus-visible {
  border: 1px solid #1976d2;
  outline: none;
}

.popper {
  position: absolute;
  right: 10px;
  top: 25px;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 778px) {
  .complete {
    background-color: #c7d2f7;
    height: 100vh;
    width: 100%;
    overflow-y: auto;
  }
  .logo {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    margin-right: 70px;
    height: 50px;
  }
  .completeForm {
    padding-top: 10px;
    margin-bottom: 200;
  }
  .heading h1 {
    text-align: initial;
    margin-top: 44px;
    margin-left: 30px;
  }
  .welcome h2 {
    /* text-align: right; */
    margin-right: 5px;
    font-size: 33px;
    /* margin-top: 38px; */
  }
  .forms {
    font-size: 18px;
    text-align: right;
    margin-right: 191px;
  }
  .forms input {
    width: 150px;
    font-size: 20px;
    height: 50px;
    text-align: left;
    margin-left: 44px;
    padding: 15px;
  }
  /* .loginButton button{
      width: 150px;
      margin-left: 2px;
      background-color: #0d47a1;
      height: 54px;
      font-size: 29px;
      color: white;
      cursor: pointer;
      border-radius: 5px;
      font-weight: 500;
  } */
  .topProjectButtons button {
    display: flex;
    position: absolute;
    top: 6px;
    right: 6px;
  }
  .buttonclass {
    padding-right: 3px;
  }
  .topButton button {
    margin-top: 60px;
    margin-bottom: 10px;
  }
  .tabs {
    z-index: -1;
    /* margin-left: -27px; */
    margin-top: 15px;
  }
  .hidetabs {
    z-index: -1;
    margin-top: 40px;
  }
  .userdiv button {
    float: right;
    margin-right: 5px;
    margin-top: 5px;
    font-size: 9px;
    width: 106px;
    height: 34px;
  }
  .hidetabss {
    margin-left: -29px;
  }
  .totals h1 {
    /* font-size: 17px;
    font-weight: 500;
    margin-bottom: -36px; */
    text-transform: uppercase;
    text-align: left;
    /* margin-left: -128px; */
    margin-top: 8px;
    padding-top: 0px;
    justify-content: center;
    height: 53px;
    display: block;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.2);
    padding: 2px 10px 5px 5px;
    padding-left: 40px;
  }
  .userdiv {
    margin-top: -45px;
  }
  .totaldiv h1 {
    font-size: 17px;
    font-weight: 500;
    padding-left: -55px;
    margin-bottom: -23px;
    text-transform: uppercase;
    text-align: center;
    margin-left: -210px;
    padding-top: 0px;
    margin-top: -10px;
    width: 157%;
    height: 50px;
    display: block;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.2);
    padding: 2px 10px 5px 5px;
  }
  .search-bar input {
    /* width: 100px;
    margin-left: 9px;
    height: 28px;
    margin-top: 12px; */
    height: 36px;
  }
  .tables {
    margin: 0px;
  }
  .logsbackground {
    margin: 0px;
  }
  .tablescrollunderdiv {
    padding-bottom: 150px;
    margin: 0px;
  }
  .tablescroll {
    overflow-x: scroll;
    overflow-y: visible;
    /* overflow: scroll; */
    margin-left: 1px;
    min-width: 100%;
  }
  .search-bar button {
    /* width: 26px; */
    height: 33px;
    /* font-size: 12px;
    margin-left: -26px; */
  }
  .allbuttons {
    flex-direction: column;
    gap: 10px;
    padding-left: 20px;
  }
  .log_bar button {
    width: 26px;
    height: 30px;
    font-size: 12px;
    margin-left: -26px;
  }
  .log_bar input {
    width: 100px;
    margin-left: 9px;
    height: 28px;
    margin-top: 12px;
  }
  .upperButton button {
    width: 65px;
    height: 30px;
    font-size: 10px;
  }
  .routesmain {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
  }
  .completeTable {
    height: calc(100vh - 125px);
    overflow: auto;
    /* padding-bottom: 150px; */
    margin: 0px;
  }
  .topActions h1 {
    /* font-size: 17px; */
    /* margin-left: -11px; */
    /* font-weight: 500; */
    /* margin-top: -10px; */
    /* margin-bottom: 9px; */
    /* text-transform: uppercase; */
    /* text-align: left; */
    display: flex;
    justify-content: left;
    padding-left: 40px;
    padding-top: 8px;
  }
  .upperButtonGroup {
    gap: 5px;
    /* margin-top: 18px; */
    grid-gap: 5px;
  }
  .topActions {
    justify-content: center;
    width: 100%;
    height: 56px;
    display: block;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    padding: 2px 10px 5px 5px;
  }
  .tophookButtons button {
    position: absolute;
    top: 6px;
    right: 6px;
  }
  .completeRows {
    display: none;
  }
  .Sidebars {
    background-color: transparent;
    display: none;
  }
  .table_container {
    font-size: 13px;
  }
  .tablestyle {
    font-size: 6px;
  }
  .topButtons {
    gap: 5px;
    display: block;
    padding-top: 4px;
  }
  .topButtons h1 {
    text-align: left;
    padding-bottom: 10px;
    padding-left: 10px;
  }
  .table {
    margin-left: 0px;
  }
  #menu__toggle {
    opacity: 0;
    display: none;
  }
  #menu__toggle:checked + .menu__btn > span {
    transform: rotate(45deg);
  }
  #menu__toggle:checked + .menu__btn > span::before {
    top: 0;
    transform: rotate(0deg);
    background-color: black;
  }
  #menu__toggle:checked + .menu__btn > span::after {
    top: 0;
    transform: rotate(90deg);
    background-color: black;
  }
  #menu__toggle:checked ~ .menu__box {
    left: -33px !important;
    z-index: 11;
    top: -5px;
  }
  .buttonAndNotification {
    width: 100%;
    height: 56px;
    gap: 10px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
    padding: 2px 10px 5px 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    /* padding: 10px 13px 15px 30px; */
  }
  .buttonAndNotification h1 {
    padding-left: 40px;
  }
  .hamburger {
    display: block;
    position: relative;
  }
  .accountInfo {
    margin: 0px 15px;
  }
  .fulltablediv {
    margin: 0px;
  }
  .changePassword {
    margin: 0px 15px;
  }
  .menu__btn {
    position: fixed;
    display: block;
    top: 24px;
    left: 10px;
    width: 17px;
    height: 15px;
    cursor: pointer;
    z-index: 112;
    padding: 20 10 20 10;
  }
  .menu__btn > span,
  .menu__btn > span::before,
  .menu__btn > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: rgba(0, 0, 0, 0.925);
    transition-duration: 0.25s;
  }
  .menu__btn > span::before {
    content: "";
    top: -8px;
  }
  .menu__btn > span::after {
    content: "";
    top: 8px;
  }
  .menu__box {
    display: block;
    position: absolute;
    top: 0;
    left: -110%;
    width: 300px;
    height: 100vh;
    margin: 0;
    z-index: 10;
    padding: 80px 0;
    list-style: none;
    background-color: #eceff1;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
    transition-duration: 0.25s;
  }
  .menu__item {
    display: block;
    padding: 12px 24px;
    color: #333;
    font-family: "Roboto", sans-serif;
    font-size: 20px;
    font-weight: 600;
    text-decoration: none;
    transition-duration: 0.25s;
  }
  .menu__item:hover {
    background-color: #58aed3;
  }
  .addservicebutton button {
    /* margin-top: -61px;
    position: relative;
    display: flex;
    width: 102px;
    margin-left: -109px;
    font-size: 9px;
    height: 30px; */
  }
  .tabtab {
    overflow: auto;
    max-width: 100%;
    max-height: calc(100vh - 120px);
  }
  .alerts {
    margin: 0px 0px 0 0px;
    background-color: #f4f7fc;
    padding: 0px;
  }
  .noti {
    overflow-y: auto;
    margin: 0px 0px 0 0px;
  }
  .notification_alerts {
    margin: 0px;
  }
  .addHookButton button {
    width: 94px;
    height: 35px;
    margin-right: 7px;
    font-size: 9px;
    margin-top: -10px;
  }
}
table th {
  padding: 12px;
  text-align: center;
  background-color: #f5f4f6;
  font-size: 16px;
  /* width: 20px; */
}

table {
  width: 100%;
  border: 1px solid #f5f4f6;
  border-spacing: 1px;
}

table td {
  padding: 12px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
}

tbody tr:nth-child(even) {
  background-color: #f5f4f6;
}

tbody tr:nth-child(odd) {
  background-color: white;
}

button {
  text-transform: uppercase;
  /* display: inline-flex; */
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  padding: 9px 11px;
  font-size: var(--font-size1);
  line-height: 1;
  font-size: 13px;
  font-weight: 500;
  gap: 8px;
  background: #007aff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid #007aff;
  border-radius: 4px;
  color: white;
}

button:hover {
  background-color: #1565c0;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.5s ease;
}

h1 {
  font-weight: 600;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./App.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;EACA,+BAAA;AACF;;AACA;EACE,UAAA;AAEF;;AAAA;EACE,mBAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,cAAA;EACA,yBAAA;AAKF;;AAHA;EACE,yBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,yBAAA;EACA,aAAA;AAOF;;AALA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAQF;;AANA;EACE,cAAA;EACA,oBAAA;AASF;;AAPA;EACE;IACE,4CAAA;EAUF;AACF;AAPA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE;IACE,uBAAA;EASF;EAPA;IACE,yBAAA;EASF;AACF;AANA;EACE;IACE,yBAAA;IACA,aAAA;IACA,WAAA;IACA,gBAAA;EAQF;EALA;IACE,aAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;IACA,YAAA;EAOF;EAJA;IACE,iBAAA;IACA,kBAAA;EAMF;EAHA;IACE,mBAAA;IACA,gBAAA;IACA,iBAAA;EAKF;EAFA;IACE,uBAAA;IACA,iBAAA;IACA,eAAA;IACA,sBAAA;EAIF;EADA;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EAGF;EAAA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,aAAA;EAEF;EACA;;;;;;;;;;KAAA;EAWA;IACE,aAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;EACF;EACA;IACE,kBAAA;EACF;EACA;IACE,gBAAA;IACA,mBAAA;EACF;EACA;IACE,WAAA;IACA,wBAAA;IACA,gBAAA;EACF;EACA;IACE,WAAA;IACA,gBAAA;EACF;EACA;IACE,YAAA;IACA,iBAAA;IACA,eAAA;IACA,cAAA;IACA,YAAA;IACA,YAAA;EACF;EACA;IACE,kBAAA;EACF;EACA;IACE;;2BAAA;IAGA,yBAAA;IACA,gBAAA;IACA,yBAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,YAAA;IACA,cAAA;IACA,+GACE;IAGF,yBAAA;IACA,kBAAA;EAFF;EAIA;IACE,iBAAA;EAFF;EAKA;IACE,eAAA;IACA,gBAAA;IACA,mBAAA;IACA,oBAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,gBAAA;IACA,iBAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,+GACE;IAGF,yBAAA;EANF;EASA;IACE;;;uBAAA;IAIA,YAAA;EAPF;EASA;IACE,WAAA;EAPF;EASA;IACE,WAAA;EAPF;EAUA;IACE,qBAAA;IACA,WAAA;EARF;EAUA;IACE,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,gBAAA;IACA,eAAA;EARF;EAUA;IACE,iBAAA;IACA,YAAA;IACA;yBAAA;EAPF;EAUA;IACE,sBAAA;IACA,SAAA;IACA,kBAAA;EARF;EAUA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EARF;EAUA;IACE,YAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;EARF;EAUA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EARF;EAUA;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;EARF;EAUA;IACE,2BAAA;IACA,cAAA;IACA,2BAAA;IACA,WAAA;EARF;EAUA;IACE,qBAAA;IACA,wBAAA;IACA,sBAAA;IACA,uBAAA;IACA,wBAAA;IACA,+BAAA;IACA,sBAAA;IACA,aAAA;IACA,qBAAA;IACA,kBAAA;IACA,gBAAA;EARF;EAWA;IACE,QAAA;IACA,sBAAA;IACA,aAAA;EATF;EAWA;IACE,uBAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,+GACE;IAGF,yBAAA;EAZF;EAeA;IACE,kBAAA;IACA,QAAA;IACA,UAAA;EAbF;EAeA;IACE,aAAA;EAbF;EAeA;IACE,6BAAA;IACA,aAAA;EAbF;EAeA;IACE,eAAA;EAbF;EAeA;IACE,cAAA;EAbF;EAeA;IACE,QAAA;IACA,cAAA;IACA,gBAAA;EAbF;EAeA;IACE,gBAAA;IACA,oBAAA;IACA,kBAAA;EAbF;EAeA;IACE,gBAAA;EAbF;EAeA;IACE,UAAA;IACA,aAAA;EAbF;EAeA;IACE,wBAAA;EAbF;EAeA;IACE,MAAA;IACA,uBAAA;IACA,uBAAA;EAbF;EAeA;IACE,MAAA;IACA,wBAAA;IACA,uBAAA;EAbF;EAeA;IACE,sBAAA;IACA,WAAA;IACA,SAAA;EAbF;EAeA;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,+GACE;IAGF,yBAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,mBAAA;IACA,kCAAA;EAhBF;EAkBA;IACE,kBAAA;EAhBF;EAkBA;IACE,cAAA;IACA,kBAAA;EAhBF;EAkBA;IACE,gBAAA;EAhBF;EAkBA;IACE,WAAA;EAhBF;EAkBA;IACE,gBAAA;EAhBF;EAkBA;IACE,eAAA;IACA,cAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,YAAA;IACA,oBAAA;EAhBF;EAkBA;;;IAGE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,sCAAA;IACA,0BAAA;EAhBF;EAkBA;IACE,WAAA;IACA,SAAA;EAhBF;EAkBA;IACE,WAAA;IACA,QAAA;EAhBF;EAkBA;IACE,cAAA;IACA,kBAAA;IACA,MAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,SAAA;IACA,WAAA;IACA,eAAA;IACA,gBAAA;IACA,yBAAA;IACA,0CAAA;IACA,0BAAA;EAhBF;EAkBA;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,iCAAA;IACA,eAAA;IACA,gBAAA;IACA,qBAAA;IACA,0BAAA;EAhBF;EAkBA;IACE,yBAAA;EAhBF;EAkBA;IACE;;;;;;mBAAA;EAVF;EAkBA;IACE,cAAA;IACA,eAAA;IACA,+BAAA;EAhBF;EAkBA;IACE,qBAAA;IACA,yBAAA;IACA,YAAA;EAhBF;EAkBA;IACE,gBAAA;IACA,qBAAA;EAhBF;EAkBA;IACE,WAAA;EAhBF;EAkBA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,cAAA;IACA,iBAAA;EAhBF;AACF;AAkBA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AAhBF;;AAkBA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAfF;;AAiBA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAdF;;AAgBA;EACE,yBAAA;AAbF;;AAeA;EACE,uBAAA;AAZF;;AAcA;EACE,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,+CAAA;EACA,mDAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAXF;;AAaA;EACE,yBAAA;EACA,mDAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;AAVF;;AAYA;EACE,gBAAA;EACA,eAAA;AATF","sourcesContent":[".App {\n  text-align: center;\n  color: #707070;\n  /* background-color: #ebedef; */\n}\n::-webkit-scrollbar {\n  width: 5px;\n}\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\nh1 {\n  color: #6c757d;\n  text-transform: uppercase;\n}\ninput {\n  border: 1px solid #dfdfdf;\n  border-radius: 4px;\n}\ninput:focus-visible {\n  border: 1px solid #1976d2;\n  outline: none;\n}\n.popper {\n  position: absolute;\n  right: 10px;\n  top: 25px;\n}\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media only screen and (max-width: 778px) {\n  .complete {\n    background-color: #c7d2f7;\n    height: 100vh;\n    width: 100%;\n    overflow-y: auto;\n  }\n\n  .logo {\n    display: flex;\n    justify-content: center;\n    margin-top: 100px;\n    margin-right: 70px;\n    height: 50px;\n  }\n\n  .completeForm {\n    padding-top: 10px;\n    margin-bottom: 200;\n  }\n\n  .heading h1 {\n    text-align: initial;\n    margin-top: 44px;\n    margin-left: 30px;\n  }\n\n  .welcome h2 {\n    /* text-align: right; */\n    margin-right: 5px;\n    font-size: 33px;\n    /* margin-top: 38px; */\n  }\n\n  .forms {\n    font-size: 18px;\n    text-align: right;\n    margin-right: 191px;\n  }\n\n  .forms input {\n    width: 150px;\n    font-size: 20px;\n    height: 50px;\n    text-align: left;\n    margin-left: 44px;\n    padding: 15px;\n  }\n\n  /* .loginButton button{\n    width: 150px;\n    margin-left: 2px;\n    background-color: #0d47a1;\n    height: 54px;\n    font-size: 29px;\n    color: white;\n    cursor: pointer;\n    border-radius: 5px;\n    font-weight: 500;\n} */\n  .topProjectButtons button {\n    display: flex;\n    position: absolute;\n    top: 6px;\n    right: 6px;\n  }\n  .buttonclass {\n    padding-right: 3px;\n  }\n  .topButton button {\n    margin-top: 60px;\n    margin-bottom: 10px;\n  }\n  .tabs {\n    z-index: -1;\n    /* margin-left: -27px; */\n    margin-top: 15px;\n  }\n  .hidetabs {\n    z-index: -1;\n    margin-top: 40px;\n  }\n  .userdiv button {\n    float: right;\n    margin-right: 5px;\n    margin-top: 5px;\n    font-size: 9px;\n    width: 106px;\n    height: 34px;\n  }\n  .hidetabss {\n    margin-left: -29px;\n  }\n  .totals h1 {\n    /* font-size: 17px;\n    font-weight: 500;\n    margin-bottom: -36px; */\n    text-transform: uppercase;\n    text-align: left;\n    /* margin-left: -128px; */\n    margin-top: 8px;\n    padding-top: 0px;\n    justify-content: center;\n    height: 53px;\n    display: block;\n    box-shadow:\n      0 2px 2px 0 rgb(0 0 0 / 14%),\n      0 3px 1px -2px rgb(0 0 0 / 12%),\n      0 1px 1px 0 rgb(0 0 0 / 20%);\n    padding: 2px 10px 5px 5px;\n    padding-left: 40px;\n  }\n  .userdiv {\n    margin-top: -45px;\n  }\n\n  .totaldiv h1 {\n    font-size: 17px;\n    font-weight: 500;\n    padding-left: -55px;\n    margin-bottom: -23px;\n    text-transform: uppercase;\n    text-align: center;\n    margin-left: -210px;\n    padding-top: 0px;\n    margin-top: -10px;\n    width: 157%;\n    height: 50px;\n    display: block;\n    box-shadow:\n      0 2px 2px 0 rgb(0 0 0 / 14%),\n      0 3px 1px -2px rgb(0 0 0 / 12%),\n      0 1px 1px 0 rgb(0 0 0 / 20%);\n    padding: 2px 10px 5px 5px;\n  }\n\n  .search-bar input {\n    /* width: 100px;\n    margin-left: 9px;\n    height: 28px;\n    margin-top: 12px; */\n    height: 36px;\n  }\n  .tables {\n    margin: 0px;\n  }\n  .logsbackground {\n    margin: 0px;\n  }\n\n  .tablescrollunderdiv {\n    padding-bottom: 150px;\n    margin: 0px;\n  }\n  .tablescroll {\n    overflow-x: scroll;\n    overflow-y: visible;\n    /* overflow: scroll; */\n    margin-left: 1px;\n    min-width: 100%;\n  }\n  .search-bar button {\n    /* width: 26px; */\n    height: 33px;\n    /* font-size: 12px;\n    margin-left: -26px; */\n  }\n  .allbuttons {\n    flex-direction: column;\n    gap: 10px;\n    padding-left: 20px;\n  }\n  .log_bar button {\n    width: 26px;\n    height: 30px;\n    font-size: 12px;\n    margin-left: -26px;\n  }\n  .log_bar input {\n    width: 100px;\n    margin-left: 9px;\n    height: 28px;\n    margin-top: 12px;\n  }\n  .upperButton button {\n    width: 65px;\n    height: 30px;\n    font-size: 10px;\n  }\n  .routesmain {\n    position: relative;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n  }\n  .completeTable {\n    height: calc(100vh - 125px);\n    overflow: auto;\n    /* padding-bottom: 150px; */\n    margin: 0px;\n  }\n  .topActions h1 {\n    /* font-size: 17px; */\n    /* margin-left: -11px; */\n    /* font-weight: 500; */\n    /* margin-top: -10px; */\n    /* margin-bottom: 9px; */\n    /* text-transform: uppercase; */\n    /* text-align: left; */\n    display: flex;\n    justify-content: left;\n    padding-left: 40px;\n    padding-top: 8px;\n  }\n\n  .upperButtonGroup {\n    gap: 5px;\n    /* margin-top: 18px; */\n    grid-gap: 5px;\n  }\n  .topActions {\n    justify-content: center;\n    width: 100%;\n    height: 56px;\n    display: block;\n    box-shadow:\n      0 2px 2px 0 rgb(0 0 0 / 14%),\n      0 3px 1px -2px rgb(0 0 0 / 12%),\n      0 1px 5px 0 rgb(0 0 0 / 20%);\n    padding: 2px 10px 5px 5px;\n  }\n\n  .tophookButtons button {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n  }\n  .completeRows {\n    display: none;\n  }\n  .Sidebars {\n    background-color: transparent;\n    display: none;\n  }\n  .table_container {\n    font-size: 13px;\n  }\n  .tablestyle {\n    font-size: 6px;\n  }\n  .topButtons {\n    gap: 5px;\n    display: block;\n    padding-top: 4px;\n  }\n  .topButtons h1 {\n    text-align: left;\n    padding-bottom: 10px;\n    padding-left: 10px;\n  }\n  .table {\n    margin-left: 0px;\n  }\n  #menu__toggle {\n    opacity: 0;\n    display: none;\n  }\n  #menu__toggle:checked + .menu__btn > span {\n    transform: rotate(45deg);\n  }\n  #menu__toggle:checked + .menu__btn > span::before {\n    top: 0;\n    transform: rotate(0deg);\n    background-color: black;\n  }\n  #menu__toggle:checked + .menu__btn > span::after {\n    top: 0;\n    transform: rotate(90deg);\n    background-color: black;\n  }\n  #menu__toggle:checked ~ .menu__box {\n    left: -33px !important;\n    z-index: 11;\n    top: -5px;\n  }\n  .buttonAndNotification {\n    width: 100%;\n    height: 56px;\n    gap: 10px;\n    box-shadow:\n      0 2px 2px 0 rgb(0 0 0 / 14%),\n      0 3px 1px -2px rgb(0 0 0 / 12%),\n      0 1px 5px 0 rgb(0 0 0 / 20%);\n    padding: 2px 10px 5px 5px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    /* padding: 10px 13px 15px 30px; */\n  }\n  .buttonAndNotification h1 {\n    padding-left: 40px;\n  }\n  .hamburger {\n    display: block;\n    position: relative;\n  }\n  .accountInfo {\n    margin: 0px 15px;\n  }\n  .fulltablediv {\n    margin: 0px;\n  }\n  .changePassword {\n    margin: 0px 15px;\n  }\n  .menu__btn {\n    position: fixed;\n    display: block;\n    top: 24px;\n    left: 10px;\n    width: 17px;\n    height: 15px;\n    cursor: pointer;\n    z-index: 112;\n    padding: 20 10 20 10;\n  }\n  .menu__btn > span,\n  .menu__btn > span::before,\n  .menu__btn > span::after {\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    background-color: rgba(0, 0, 0, 0.925);\n    transition-duration: 0.25s;\n  }\n  .menu__btn > span::before {\n    content: '';\n    top: -8px;\n  }\n  .menu__btn > span::after {\n    content: '';\n    top: 8px;\n  }\n  .menu__box {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: -110%;\n    width: 300px;\n    height: 100vh;\n    margin: 0;\n    z-index: 10;\n    padding: 80px 0;\n    list-style: none;\n    background-color: #eceff1;\n    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);\n    transition-duration: 0.25s;\n  }\n  .menu__item {\n    display: block;\n    padding: 12px 24px;\n    color: #333;\n    font-family: 'Roboto', sans-serif;\n    font-size: 20px;\n    font-weight: 600;\n    text-decoration: none;\n    transition-duration: 0.25s;\n  }\n  .menu__item:hover {\n    background-color: #58aed3;\n  }\n  .addservicebutton button {\n    /* margin-top: -61px;\n    position: relative;\n    display: flex;\n    width: 102px;\n    margin-left: -109px;\n    font-size: 9px;\n    height: 30px; */\n  }\n  .tabtab {\n    overflow: auto;\n    max-width: 100%;\n    max-height: calc(100vh - 120px);\n  }\n  .alerts {\n    margin: 0px 0px 0 0px;\n    background-color: #f4f7fc;\n    padding: 0px;\n  }\n  .noti {\n    overflow-y: auto;\n    margin: 0px 0px 0 0px;\n  }\n  .notification_alerts {\n    margin: 0px;\n  }\n  .addHookButton button {\n    width: 94px;\n    height: 35px;\n    margin-right: 7px;\n    font-size: 9px;\n    margin-top: -10px;\n  }\n}\ntable th {\n  padding: 12px;\n  text-align: center;\n  background-color: #f5f4f6;\n  font-size: 16px;\n  /* width: 20px; */\n}\ntable {\n  width: 100%;\n  border: 1px solid #f5f4f6;\n  border-spacing: 1px;\n}\ntable td {\n  padding: 12px;\n  text-align: center;\n  cursor: pointer;\n  font-size: 14px;\n}\ntbody tr:nth-child(even) {\n  background-color: #f5f4f6;\n}\ntbody tr:nth-child(odd) {\n  background-color: white;\n}\nbutton {\n  text-transform: uppercase;\n  /* display: inline-flex; */\n  white-space: nowrap;\n  align-items: center;\n  justify-content: center;\n  padding: 9px 11px;\n  font-size: var(--font-size1);\n  line-height: 1;\n  font-size: 13px;\n  font-weight: 500;\n  gap: 8px;\n  background: #007aff 0% 0% no-repeat padding-box;\n  box-shadow: 0px 3px 6px #00000029;\n  border: 1px solid #007aff;\n  border-radius: 4px;\n  color: white;\n}\nbutton:hover {\n  background-color: #1565c0;\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.5s ease;\n}\nh1 {\n  font-weight: 600;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
